import { Button, Dropdown, Form, FormInstance, Row } from 'antd';
import React, { useCallback } from 'react';

import { ReactComponent as Filter } from "assets/img/filter.svg"

import styles from "./styles.module.scss";

interface IFilter {
  contentFilter: React.ReactNode;
  onOk?: () => void;
  form?: FormInstance;
  resetFunc?: () => void;
  hidden?: boolean;
  onlyIcon?: boolean;
}

const FilterComponent = (props: IFilter) => {
  const {
    contentFilter,
    onOk,
    form,
    resetFunc,
    hidden,
    onlyIcon = false,
  } = props;

  
  const reset = useCallback(() => {
    if (resetFunc) {
      resetFunc();
    }
  }, []);

  return (
    <Dropdown
      placement="bottomRight"
      trigger={['click']}
      dropdownRender={() => (
        <Form form={form} layout="vertical" onFinish={onOk}>
          <div className={styles.container}>
            <div className={styles.title}>Log Updated Date Filter</div>
            <div className={styles.content}>{contentFilter}</div>
            <Row justify="space-between">
              <Button onClick={reset}>Reset</Button>
              <Button type="primary" htmlType="submit">
                Apply
              </Button>
            </Row>
          </div>
        </Form>
      )}
    >
      <Button className={styles.filter} hidden={hidden}>
        <Filter /> {!onlyIcon && <span>Filter</span>}
      </Button>
    </Dropdown>
  );
};

export default FilterComponent;
